import { convertAttributesToBoolean, mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_COST_OBJECTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { CostObjectOriginal } from './types'

export async function getCostObjectList() {
  const costObjects = await get<CostObjectOriginal[]>(API_ROUTE_ADMIN_COST_OBJECTS)
  const camelCaseCostObjects = mapKeysToCamelCase(costObjects)

  const parsedCostObjects = camelCaseCostObjects.map(costObject =>
    convertAttributesToBoolean(costObject, 'isHidden')
  )

  return parsedCostObjects
}
